<script setup lang="ts">
import type { EventStoryblok, Story } from '@/types'
import { eventStructuredDataAdapter } from '@/utils/structured-data-adapters'

const config = useRuntimeConfig()

const storyblokApi = useStoryblokApi()

const events = ref<Story<EventStoryblok>[]>([])
const heroVersion = computed(() => {
  return events.value.length
    ? {
        index: 0,
        name: 'hero',
      }
    : {
        index: 1,
        name: 'hero-no-events',
      }
})

const [{ data }, { story }] = await Promise.all([
  useAsyncData(
    'events-data',
    async () =>
      await storyblokApi.get('cdn/stories', {
        version: config.public.storyblokApiVersion as 'draft' | 'published',
        starts_with: 'events',
        resolve_relations: 'event.representatives',
        per_page: 100,
        filter_query: {
          component: {
            in: 'event',
          },
          end_date: {
            gt_date: formatDate(new Date()),
          },
        },
      }),
  ),
  useFetchStory('events'),
])
const { layoutName, layoutNavbarColor, layoutFooterColor } =
  useLayout<any>(story)

events.value = data.value?.data.stories

useCustomHead(story, {
  jsonLd: events.value.map((event) => {
    return eventStructuredDataAdapter(event)
  }),
})
</script>

<template>
  <NuxtLayout
    :name="layoutName"
    :navbar-color="layoutNavbarColor"
    :footer-color="layoutFooterColor"
  >
    <div v-if="story">
      <StoryblokComponent
        v-if="heroVersion.name === 'hero'"
        :blok="story.content.hero[0]"
        :add-nav-height="true"
      />
      <div v-else>
        <StoryblokComponent
          :blok="story.content.hero[1]"
          :add-nav-height="true"
        />
        <StoryblokComponent :blok="story.content.hero[2]" />
      </div>
      <section class="bg-paper-100">
        <EventLists v-if="events.length" :events="events" />
      </section>
      <StoryblokComponent
        v-for="section in story.content.body"
        :key="section._uid"
        :blok="section"
      />
    </div>
  </NuxtLayout>
</template>
